const NewFundsVerification = () => import('@/views/main/report/newFundsVerification/FundsVerification.vue')
export default {
  path: '/main/report/newFundsVerification',
  name: 'newFundsVerification',
  component: NewFundsVerification,
  children: []
}
